import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { Fragment, useState } from 'react';

import { SORT } from '@jebel/constants';

import { InviteMemberModal } from 'shared/components/dialogs';
import { Typography } from 'shared/components/ui';
import { SpreadsheetProvider } from 'shared/features/spreadsheet/providers';
import { useCrudPermissions } from 'shared/hooks';

import { SearchProvider } from '../../../shared/features/search';
import { MembersSpreadsheet } from './MembersSpreadsheet';
import { MembersStats } from './MembersStats';

const FALLBACK_SORT = { sort: { createdAt: SORT.desc }, order: SORT.desc, headcellId: 'createdAt' };

export function MembersContent() {
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);

  const { membersPermissions } = useCrudPermissions();

  const onModalClose = () => {
    setIsInviteModalOpen(false);
  };

  const onModalOpen = () => {
    setIsInviteModalOpen(true);
  };

  return (
    <Fragment>
      <InviteMemberModal open={isInviteModalOpen} onClose={onModalClose} isAdminInviting />

      <Content>
        <Header>
          <Typography variant="subtitle2" color="primary">
            Members
          </Typography>

          {membersPermissions.add && (
            <Button color="primary" variant="contained" onClick={onModalOpen}>
              Invite
            </Button>
          )}
        </Header>

        <MembersStats />

        <SpreadsheetProvider defaultSortOption={FALLBACK_SORT}>
          <SearchProvider>
            <MembersSpreadsheet />
          </SearchProvider>
        </SpreadsheetProvider>
      </Content>
    </Fragment>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
